import React from 'react';

import { cn } from '@/lib/utils';

import { Text } from '@/decodo/components/atoms//Text';
import Card from '@/decodo/components/atoms/Card';
import { OfferCountdownStatus } from '@/decodo/components/atoms/countdown';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';

export type BannerProps = {
  title: string;
  description: React.ReactNode;
  direction: 'column' | 'row' | null;
  image: React.ReactNode;
  countdownExpiry?: string | null;
  button?: LinkButtonStrapiProps;
  classNames?: {
    root?: string;
  };
};

export default function Banner({
  button,
  image,
  title,
  description,
  direction,
  classNames,
  countdownExpiry,
}: BannerProps) {
  const hasCountdown = !!countdownExpiry;

  return (
    <Card
      classNames={{
        root: cn(
          'flex flex-col gap-10 lg:gap-6 dark:bg-transparent bg-transparent p-6',
          classNames?.root
        ),
      }}
      color='gradient'
    >
      <div className='flex flex-row items-center gap-4'>
        <div
          className={cn(
            'items-center text-left md:flex md:flex-grow md:gap-x-6',
            hasCountdown && 'gap-5 lg:gap-x-6 lg:gap-y-6'
          )}
        >
          {!!image && image}
          <div className='space-y-3 pt-5 md:pt-0'>
            <Text
              variant='subtitle-l-d'
              color='gray-950'
              classNames={{ wrapper: 'font-serif' }}
            >
              {title}
            </Text>
            {!!description && <Text color='gray-500'>{description}</Text>}
          </div>
        </div>
        {button && (
          <div className={cn('hidden', direction === 'row' && 'lg:block')}>
            <LinkButton
              href={button.url}
              variant='outlined'
              color='secondary'
              fullwidth={true}
            >
              {button.text}
            </LinkButton>
          </div>
        )}
      </div>

      {hasCountdown && (
        <div className='mt-3 flex justify-center rounded-xl bg-gray-800 p-4'>
          <OfferCountdownStatus expiry={countdownExpiry} />
        </div>
      )}

      {button && (
        <div className={cn(direction === 'row' && 'lg:hidden')}>
          <LinkButton
            href={button.url}
            variant='outlined'
            color='secondary'
            fullwidth={true}
          >
            {button.text}
          </LinkButton>
        </div>
      )}
    </Card>
  );
}
